import { render, staticRenderFns } from "./ShowYwInfo.vue?vue&type=template&id=3db45fd3&scoped=true&"
import script from "./ShowYwInfo.vue?vue&type=script&lang=js&"
export * from "./ShowYwInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db45fd3",
  null
  
)

export default component.exports